import { __assign, __awaiter, __generator } from "tslib";
import { WixOOISDKAdapter } from '@wix/bookings-adapter-ooi-wix-sdk';
import { FedopsAdapter } from '@wix/bookings-adapters-reporting/dist/src/fedops/fedops-adapter';
import { DailyTimetableSettingsKeys } from '@wix/bookings-app-builder-settings-const/dist/src/DailyTimeTable/Settings.const';
import { RefreshAppContextContextBuilder, } from '@wix/bookings-app-builder-settings-const/dist/src/DailyTimeTable/refresh-app-context';
import { dateToShiftedRfcString, getFirstDayOfTheWeek, } from '@wix/bookings-date-time';
import Experiments from '@wix/wix-experiments';
import moment from 'moment';
import { BookingsAPI } from '../api/bookingsAPI';
import { getSettings } from '../app-settings/app-settings';
import { BiLogger } from '../bi-logger/bi-logger';
import { WidgetName } from '../bi-logger/bi.const';
import { WidgetServices } from '../platform/platform-services';
import { DAILY_TIMETABLE_WIDGET_ID } from '../platform/platform.const';
import DataPersister from '../utils/data-persister';
import { getFlowApiEnvironment } from '../utils/getFlowApiEnvironment';
import { LanguageState } from '../utils/languageState';
import { SlotsListViewModel } from './slots-list.view-model';
import { WeeklyDayPickerViewModel, } from './weekly-day-picker.view-model';
var DEFAULT_LANGUAGE = 'en';
var isSundayFirstDay = function (catalogData) {
    return (getFirstDayOfTheWeek(catalogData.businessInfo.dateRegionalSettingsLocale) === 0);
};
var isTextDefinedInSettings = function (settings, key) {
    return settings[key] !== undefined;
};
var getAvailabilitySlots = function (catalogData, date, slotsListViewModel, httpAdapter, settings) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, slotsListViewModel.setLoading()];
            case 1:
                _a.sent();
                return [2 /*return*/, httpAdapter.getAvailabilitySlots(catalogData, date.format('YYYY-MM-DDTHH:mm:ss'), settings)];
        }
    });
}); };
var getTimetableConfig = function (_a) {
    var httpAdapter = _a.httpAdapter, appDefId = _a.appDefId, externalId = _a.externalId, wixCodeApi = _a.wixCodeApi, appInstanceId = _a.appInstanceId;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, catalogData_1, componentSettings_1, _c, catalogData, bookingEntries, componentSettings, firstAvailableDate, initialSlots;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!(wixCodeApi.window.rendering.env === 'backend')) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.all([
                            httpAdapter.getCatalogData(),
                            getSettings({
                                appDefId: appDefId,
                                externalId: externalId,
                                appInstanceId: appInstanceId,
                            }),
                        ])];
                case 1:
                    _b = _d.sent(), catalogData_1 = _b[0], componentSettings_1 = _b[1];
                    return [2 /*return*/, {
                            catalogData: catalogData_1,
                            componentSettings: componentSettings_1,
                            bookingEntries: [],
                            firstAvailableDate: dateToShiftedRfcString(new Date()),
                            initialSlots: [],
                        }];
                case 2: return [4 /*yield*/, Promise.all([
                        httpAdapter.getCatalogData(),
                        httpAdapter.getBookings(),
                        getSettings({
                            appDefId: appDefId,
                            externalId: externalId,
                            appInstanceId: appInstanceId,
                        }),
                    ])];
                case 3:
                    _c = _d.sent(), catalogData = _c[0], bookingEntries = _c[1], componentSettings = _c[2];
                    return [4 /*yield*/, httpAdapter.getNextAvailableDate(catalogData, componentSettings)];
                case 4:
                    firstAvailableDate = _d.sent();
                    return [4 /*yield*/, httpAdapter.getAvailabilitySlots(catalogData, firstAvailableDate, componentSettings)];
                case 5:
                    initialSlots = _d.sent();
                    return [2 /*return*/, {
                            catalogData: catalogData,
                            bookingEntries: bookingEntries,
                            firstAvailableDate: firstAvailableDate,
                            componentSettings: componentSettings,
                            initialSlots: initialSlots,
                        }];
            }
        });
    });
};
var dataPersister = new DataPersister();
function setUpTimeTable(appParams, $w, $widget, wixSdkAdapter, environment, fedopsAdapter, refreshAppContext, externalId, experiments, essentials, wixCodeApi, platformAPIs, languageState) {
    return __awaiter(this, void 0, void 0, function () {
        var biLogger, httpAdapter, businessTimezone, language, failedTranslationFetch, _a, translations, _b, catalogData, bookingEntries, firstAvailableDate, componentSettings, initialSlots, e_1, settings, slotsListViewModel, selectedDate, dateRegionalSettingsLocale, sundayAsFirstDay, onDaySelected, getTranslation, dayPickerViewModel, setSessions, reportAppLoaded;
        var _this = this;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    biLogger = new BiLogger(wixSdkAdapter, WidgetName.DAILY_TIMETABLE);
                    return [4 /*yield*/, experiments.ready()];
                case 1:
                    _c.sent();
                    httpAdapter = new BookingsAPI(appParams.instance, platformAPIs, wixCodeApi, appParams, experiments, essentials.httpClient, essentials.errorHandler);
                    businessTimezone = wixCodeApi.site.timezone || 'UTC';
                    language = languageState.getCurrentLanguage();
                    failedTranslationFetch = false;
                    if (!environment.isEditorMode && !environment.isPreviewMode) {
                        fedopsAdapter.logInteractionStarted('get-tt-data');
                    }
                    return [4 /*yield*/, Promise.all([
                            dataPersister.getOrFetch(function () {
                                return httpAdapter
                                    .getTranslations(language)
                                    .catch(function () {
                                    return httpAdapter
                                        .getTranslations(language)
                                        .catch(function () { return (failedTranslationFetch = true); });
                                });
                            }, refreshAppContext.shouldFetchServices),
                            dataPersister.getOrFetch(function () {
                                return getTimetableConfig({
                                    httpAdapter: httpAdapter,
                                    appDefId: appParams.appDefinitionId,
                                    wixCodeApi: wixCodeApi,
                                    externalId: externalId,
                                    appInstanceId: appParams.instanceId,
                                    experiments: experiments,
                                });
                            }, refreshAppContext.shouldFetchServices),
                        ])];
                case 2:
                    _a = _c.sent(), translations = _a[0], _b = _a[1], catalogData = _b.catalogData, bookingEntries = _b.bookingEntries, firstAvailableDate = _b.firstAvailableDate, componentSettings = _b.componentSettings, initialSlots = _b.initialSlots;
                    if (!environment.isEditorMode && !environment.isPreviewMode) {
                        fedopsAdapter.logInteractionEnded('get-tt-data');
                    }
                    if (!failedTranslationFetch) return [3 /*break*/, 6];
                    languageState.setCurrentLanguage(DEFAULT_LANGUAGE);
                    language = languageState.getCurrentLanguage();
                    _c.label = 3;
                case 3:
                    _c.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, httpAdapter.getTranslations(language)];
                case 4:
                    translations = _c.sent();
                    return [3 /*break*/, 6];
                case 5:
                    e_1 = _c.sent();
                    console.error("Failed to get translations for default language - ".concat(language, ": ").concat(e_1.message));
                    return [3 /*break*/, 6];
                case 6:
                    settings = __assign(__assign({}, componentSettings), refreshAppContext.updatedSettings);
                    if (isTextDefinedInSettings(settings, DailyTimetableSettingsKeys.TIMETABLE_HEADING_TEXT)) {
                        $w('#timetableTitle').text =
                            settings[DailyTimetableSettingsKeys.TIMETABLE_HEADING_TEXT] ||
                                translations['bookings.daily-timetable.title'];
                    }
                    if (isTextDefinedInSettings(settings, DailyTimetableSettingsKeys.EMPTY_STATE_TEXT)) {
                        $w('#messageText').text =
                            settings[DailyTimetableSettingsKeys.EMPTY_STATE_TEXT] ||
                                translations['bookings.daily-timetable.empty-state'];
                    }
                    slotsListViewModel = new SlotsListViewModel({
                        $w: $w,
                        $widget: $widget,
                        wixCodeApi: wixCodeApi,
                        appParams: appParams,
                        biLogger: biLogger,
                        bookingsApi: httpAdapter,
                        timetableSettings: settings,
                        catalogData: catalogData,
                        bookingEntries: bookingEntries,
                        translations: translations,
                        platformAPIs: platformAPIs,
                        languageState: languageState,
                    });
                    selectedDate = moment(firstAvailableDate.substring(0, 10));
                    dateRegionalSettingsLocale = catalogData.businessInfo.dateRegionalSettingsLocale;
                    sundayAsFirstDay = isSundayFirstDay(catalogData);
                    onDaySelected = function (date, navigationInfo) { return __awaiter(_this, void 0, void 0, function () {
                        var availabilitySlots;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, getAvailabilitySlots(catalogData, date, slotsListViewModel, httpAdapter, settings)];
                                case 1:
                                    availabilitySlots = _a.sent();
                                    biLogger.sendTimetableNavigationEvent(__assign(__assign({}, navigationInfo), { additionalInfo: date.toISOString(), isEmptyState: availabilitySlots.length === 0 }));
                                    return [2 /*return*/, setSessions(availabilitySlots)];
                            }
                        });
                    }); };
                    getTranslation = function (key) { return translations[key]; };
                    dayPickerViewModel = new WeeklyDayPickerViewModel({
                        $widget: $widget,
                        $w: $w,
                        getTranslation: getTranslation,
                        onDaySelected: onDaySelected,
                        sundayAsFirstDay: sundayAsFirstDay,
                        dateRegionalSettingsLocale: dateRegionalSettingsLocale,
                        wixCodeApi: wixCodeApi,
                        languageState: languageState,
                    });
                    setSessions = function (newSessions, isInitialLoad) {
                        if (isInitialLoad === void 0) { isInitialLoad = false; }
                        return slotsListViewModel.setSlotsList(newSessions, businessTimezone, isInitialLoad);
                    };
                    reportAppLoaded = function (slots) {
                        fedopsAdapter.logAppLoaded();
                        biLogger.sendTimetableLoadedEvent({
                            additionalInfo: selectedDate.toISOString(),
                            isEmptyState: slots.length === 0,
                        });
                        dataPersister.set("APP_LOADED_LOGGED" /* DataKeys.APP_LOADED_LOGGED */, true);
                    };
                    // Leave SSR in loading state so it shows with loader and SSR cache is meaningful
                    if (environment.isSSR) {
                        slotsListViewModel.setCleanMode();
                        dayPickerViewModel.hideAllElements();
                    }
                    else {
                        void setSessions(initialSlots, true);
                        dayPickerViewModel.setSelectedDate(selectedDate);
                        // Show hidden elements when not in SSR (we must hide them in SSR since data is dynamic) #SCHED-19226
                        dayPickerViewModel.hideAllElements();
                        dayPickerViewModel.showAllElements();
                    }
                    if (!dataPersister.get("APP_LOADED_LOGGED" /* DataKeys.APP_LOADED_LOGGED */)) {
                        reportAppLoaded(initialSlots);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function createRefreshAppContext(_a) {
    var refreshAppInput = _a.refreshAppInput, isPreviewMode = _a.isPreviewMode;
    var refreshAppContext;
    if (typeof refreshAppInput === 'object' && refreshAppInput) {
        refreshAppContext = refreshAppInput;
    }
    else {
        var refreshAppContextContextBuilder = new RefreshAppContextContextBuilder();
        if (refreshAppInput) {
            refreshAppContextContextBuilder.shouldFetchServices();
        }
        else {
            refreshAppContextContextBuilder.shouldNotFetchServices();
        }
        refreshAppContext = refreshAppContextContextBuilder.build();
    }
    // need to investigate - when switching to preview mode in editor, the loader will get stuck, adding 'isPreviewMode' solves it (talk to Or if not sure)
    if (isPreviewMode) {
        refreshAppContext.shouldFetchServices = true;
    }
    return refreshAppContext;
}
export var createWidgetController = function (_a, ravenReporter) {
    var compId = _a.compId, $w = _a.$w, appParams = _a.appParams, platformAPIs = _a.platformAPIs, wixCodeApi = _a.wixCodeApi, livePreviewOptions = _a.livePreviewOptions, externalId = _a.externalId;
    return __awaiter(void 0, void 0, void 0, function () {
        var environment, experiments, wixSdkAdapter, languageState, fedopsAdapter, widgetProps, widgetServices, $widget, initialControllerAPI, shouldFetchData, refreshAppContext;
        return __generator(this, function (_b) {
            environment = getFlowApiEnvironment(wixCodeApi);
            experiments = new Experiments({
                scopes: ['bookings-viewer-script', 'wix-bookings-client'],
                baseUrl: environment.isSSR ? 'https://wix.com' : '',
            });
            wixSdkAdapter = new WixOOISDKAdapter(wixCodeApi, platformAPIs, appParams, compId, experiments);
            languageState = new LanguageState(wixCodeApi.site.language);
            fedopsAdapter = new FedopsAdapter(wixSdkAdapter, DAILY_TIMETABLE_WIDGET_ID);
            widgetProps = {};
            widgetServices = new WidgetServices(widgetProps);
            $widget = widgetServices.get$widget($w);
            initialControllerAPI = {};
            $widget.onPropsChanged(function () { });
            shouldFetchData = livePreviewOptions && livePreviewOptions.shouldFetchData;
            refreshAppContext = createRefreshAppContext({
                refreshAppInput: shouldFetchData,
                isPreviewMode: environment.isPreviewMode,
            });
            return [2 /*return*/, {
                    pageReady: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            try {
                                return [2 /*return*/, setUpTimeTable(appParams, $w, $widget, wixSdkAdapter, environment, fedopsAdapter, refreshAppContext, externalId, experiments, platformAPIs.essentials, wixCodeApi, platformAPIs, languageState)];
                            }
                            catch (e) {
                                ravenReporter("daily timetable failed with error ".concat(e));
                                throw e;
                            }
                            return [2 /*return*/];
                        });
                    }); },
                    exports: function () {
                        return widgetServices.generateControllerAPI($widget, initialControllerAPI);
                    },
                }];
        });
    });
};
//# sourceMappingURL=daily-timetable.controller.js.map